import { render, staticRenderFns } from "./PortfolioHeader.vue?vue&type=template&id=20f7c2ed&scoped=true"
var script = {}
import style0 from "./PortfolioHeader.vue?vue&type=style&index=0&id=20f7c2ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7c2ed",
  null
  
)

export default component.exports